import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { camelToDisplay } from '@iotv/datamodel-core';
import { TabContext, TabList } from '@mui/lab';
import { Tab, Typography } from '@mui/material';
import { useTabHandler } from '../../../hooks/useTabHandler';
import { FilteredTree } from './tabs';
import { GatewayQuery } from './tabs/GatewayQuery';
import { LNSMetricsTab } from './tabs/LNSMetrics';
import { AutoCompleteSearch } from './tabs/AutoCompleteSearch';
import { AWOLIncidents } from './tabs/AWOLIncidents';
import { GatewayMetricsTab } from './tabs/GatewayMetrics';
import { DeviceMetricsTab } from './tabs/DeviceMetrics';
export const Slot4 = ({}) => {
    const tabsToDisplay = {
        autoCompleteSearch: (value) => _jsx(AutoCompleteSearch, { value }),
        filteredTree: (value) => _jsx(FilteredTree, { value }),
        gatewayQuery: (value) => _jsx(GatewayQuery, { value }),
        awolIncidents: (value) => _jsx(AWOLIncidents, { value }),
        lnsMetrics: (value) => _jsx(LNSMetricsTab, { value }),
        gatewayMetrics: (value) => _jsx(GatewayMetricsTab, { value }),
        deviceMetrics: (value) => _jsx(DeviceMetricsTab, { value }),
    };
    const { handlers: { handleTabChange }, state: [[tabIdx, setTabIdx]], } = useTabHandler(tabsToDisplay);
    const getTabName = (idx) => Object.keys(tabsToDisplay)[idx];
    const getTabIndex = (str) => Object.keys(tabsToDisplay).indexOf(str);
    return (_jsxs("div", { children: [_jsx(Typography, { variant: 'h6', children: "Slot 4 Developer only examples" }), _jsxs(TabContext, { value: getTabName(tabIdx), children: [_jsx(TabList, { onChange: (e, newTabName) => setTabIdx(getTabIndex(newTabName)), children: Object.keys(tabsToDisplay).map((k) => (_jsx(Tab, { label: camelToDisplay(k), value: k }, k))) }), Object.entries(tabsToDisplay).map(([k, fn]) => fn(k))] })] }));
};
